import { Box, BoxProps } from "@hightouch/htui";

export const Icon = (props: BoxProps) => (
  <Box
    as="svg"
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.527 20.839a10 10 0 0 1-10.378-.99l-.28-.218-.077-.068a1 1 0 0 1 1.25-1.55l.082.061.225.175a8.001 8.001 0 1 0-.405-12.476 1 1 0 0 1-1.301-1.519 10.002 10.002 0 0 1 14.866 2.108 10.001 10.001 0 0 1-3.982 14.477ZM3.63 16.419c-.882.434-1.795-.531-1.313-1.388l1.471-2.607a1 1 0 0 0 .007-.972l-1.516-2.77c-.472-.862.454-1.816 1.33-1.371l7.335 3.723a1 1 0 0 1-.01 1.79L3.63 16.418Z"
    />
  </Box>
);
